import { useMutation, useQuery, useQueryClient } from 'react-query';
import { request } from './request';

const queryKeys = {
  accessLogs: 'accessLogs',
  createAccessLog: 'createAccessLog',
};

const fetchFilteredAccessLogs = async (filter, documentSuperId) => {
  const body = {
    documentIds: filter.document,
    sectionIds: filter.section,
    userIds: filter.user,
    startDate: filter.startDate,
    endDate: filter.endDate,
  };
  const res = await request.post(`/gaby/access-logs/filter`, { filter: body, documentSuperId });
  return res.data;
};

export const useAccessLogs = (filter, documentSuperId) => {
  return useQuery(['accessLogs', documentSuperId, filter], () => fetchFilteredAccessLogs(filter, documentSuperId));
};

export const useAccessLogsFilters = (documentSuperId) => {
  return useQuery(
    ['accessLogsFilters'],
    async () => {
      const res = await request.get(`/gaby/access-logs/filter/${documentSuperId}`);
      return res.data;
    },
    {
      keepPreviousData: true,
    }
  );
};

export const useCreateAccessLog = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ['createAccessLog'],
    async ({ sectionSuperId, documentSuperId, organizationId }) => {
      const res = await request.post(`/gaby/access-logs`, { sectionSuperId, documentSuperId, organizationId: organizationId });
      return res.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(queryKeys.accessLogs);
      },
    }
  );
};
